module.exports = __webpack_public_path__ + "static/star-formation-and-black-holes-7af817bb56f7127fa71cbb66901994a3.webp";